import axios from "axios";
import config from "../config/config";

export const axiosInstance = axios.create({
  baseURL: config.apiBaseUrl,
});

export const axiosNodeInstance = axios.create({
  baseURL: config.nodeApiUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});

export const axiosPythonInstance = axios.create({
  baseURL: config.pythonApiUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});